import { render, staticRenderFns } from "./RoleManagementAdmin.vue?vue&type=template&id=355cf04a&scoped=true&"
import script from "./RoleManagementAdmin.vue?vue&type=script&lang=ts&"
export * from "./RoleManagementAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./RoleManagementAdmin.vue?vue&type=style&index=0&id=355cf04a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355cf04a",
  null
  
)

export default component.exports